// personal-desktop.component.ts
import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { PoolService } from "src/app/services/pool.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ParamService } from "src/app/services/param.service";
export interface Language {
  label: string;
  labelName: string;
}

export interface LanguageMap {
  [key: string]: Language;
}

@Component({
  selector: "app-personal-desktop",
  templateUrl: "./personal-desktop.component.html",
  styleUrls: ["./dashboard.component.scss"], // Ortak stilleri kullanabilir
})
export class PersonalDesktopComponent implements OnInit, OnDestroy {
  public employeeName: string = "";
  public activeShift: any | null = null;
  public leaveSummary: any | null = { remaining: 0, used: 0, total: 0 };
  public punchMovements: any[] = [];
  public dasboardInfo: any = {};
  companyId: number = Number(sessionStorage.getItem("companyid"));
  private _subscription: Subscription = new Subscription();
  isLoading: boolean = true;
  language: any = [];
  languageMap: LanguageMap = {};
  public isRefreshing: boolean = false;

  constructor(
    private poolService: PoolService,
    private paramService: ParamService,
    private snackBar: MatSnackBar,
  ) {}

  getLanguage(lng: any) {
    let data;
    this.paramService.getLanguageInfo().subscribe(
      (res: any) => {
        Object.keys(res).forEach((key) => {
          let data = { label: res[key].label, labelName: res[key].labelName };
          this.language.push(data);
        });

        // let languageMap: LanguageMap = {};
        this.language.forEach((s: Language) => {
          this.languageMap[s.label] = s;
        });

        this.loadEmployeeDashboardData();
      },
      (err) => {
        console.log(err);
      },
    );
  }

  ngOnInit() {
    this.getLanguage(JSON.parse(localStorage.getItem("language")!).id);
  }

  private loadEmployeeDashboardData(): void {
    // Angular 7 / RxJS 6 standartlarında abonelik (Subscription) yönetimi
    this.isLoading = true;
    let config = new MatSnackBarConfig();
    config.panelClass = ["message-position"];
    this.snackBar.open(
      this.languageMap["PROCESS_IN_PROGRESS"].labelName,
      "",
      config,
    );
    const dataSub = this.poolService.loadEmployeeDashboardData().subscribe(
      (response: any) => {
        if (response) {
          this.isLoading = false;
          this.employeeName = JSON.parse(
            sessionStorage.getItem("userinfo") || '""',
          );
          this.dasboardInfo = response;
          this.snackBar.dismiss();
        }
      },
      (error) => {
        console.error("Özet verileri yüklenirken hata oluştu:", error);
        this.isLoading = false;
      },
    );

    this._subscription.add(dataSub);
  }

  public refreshDashboard() {
    if (this.isRefreshing) return; // Zaten çalışıyorsa ikinciye tetikleme

    this.isRefreshing = true;
    this.loadDashboardData(); // Güncel verileri havuzdan yeniden çek
  }

  // Verileri Backend servisinden çeken ana metot
  private loadDashboardData() {
    this.poolService.loadEmployeeDashboardData().subscribe(
      (data) => {
        console.log(data);
        this.dasboardInfo = data;
        this.isRefreshing = false; // Veri gelince animasyonu durdur
      },
      (error) => {
        console.error("Veri çekilirken hata oluştu:", error);
        this.isRefreshing = false;
      },
    );
  }

  ngOnDestroy() {
    // Angular 7'de hafıza sızıntısını (memory leak) önlemek için mutlaka unsubscribe yapıyoruz
    this._subscription.unsubscribe();
  }
}
